// extracted by mini-css-extract-plugin
module.exports = {"Christie":"TextGroupSectionC_Christie__qAYaf","TextContainer":"TextGroupSectionC_TextContainer__3vZC1"};